// extracted by mini-css-extract-plugin
export default {"container":"Owner_container__ncXLW","mainContent":"Owner_mainContent__545sN","name":"Owner_name__KSdLl","jobTitle":"Owner_jobTitle__-w9GW","contact":"Owner_contact__ff4AY"};